<template>
    <div>
        <div class="form-horizontal">

            <form-input :form="form" property="active">
                <input type="checkbox" v-model="form.active">
            </form-input>

            <form-input :form="form" property="title"></form-input>
            <form-input :form="form" property="slug"></form-input>
            <form-input :form="form" property="keyword"></form-input>
            <form-input :form="form" property="keywords"></form-input>
            <form-input :form="form" property="description">
                <textarea v-model="form.description" class="form-control" cols="10" rows="5"></textarea>
            </form-input>

            <!--<form-input :form="form" property="body">-->
                <!--<textarea v-model="form.body" class="form-control" cols="10" rows="5"></textarea>-->
            <!--</form-input>-->

            <form-input :form="form" property="body">
                <text-editor v-model="form.body"></text-editor>
            </form-input>


            <!--<form-input-trans :form="form" property="body">-->
                <!--<template slot-scope="props">-->
                    <!--<text-editor v-model="form.body[props.lang]"></text-editor>-->
                <!--</template>-->
            <!--</form-input-trans>-->

            <form-input :form="form" property="image" label="Photo">
                <photo-upload @input="files.image = $event" :value="form.image.url" @clear="files.image = null; form.image = {url: ''}"></photo-upload>
            </form-input>

            <form-input-trans :form="form" property="image.alt" label="Alt">
                <template slot-scope="props">
                    <div class="input-group">
                        <input type="text" v-model="form.image.alt[props.lang]" class="form-control" />
                        <span class="input-group-btn">
                            <button @click.prevent="copyTitle(props.lang)" class="btn btn-secondary" type="button">Make Alt</button>
                        </span>
                    </div>
                </template>
            </form-input-trans>
        </div>
    </div>
</template>


<script>
import Model from 'lib/Model';
import Form from 'lib/Form';
import UploadFiles from 'lib/UploadFiles';

export default {
    mixins: [Model, UploadFiles],
    data() {
        return {
            active: 'form',
            method: '/api/pages',
            propertiesConfig: Spark.properties,
            form: new Form(() => {
                return {
                    active: false,
                    title: null,
                    slug: null,
                    keyword: null,
                    keywords: null,
                    description: null,
                    body: null,
                    image: {
                        alt: {}
                    },
                };
            })
        };
    },
    methods: {
        toggleActive(lang) {
            this.form.active[lang] = !this.form.active[lang];
        },

        copyTitle(lang) {
            this.form.image.alt = Object.assign({}, this.form.image.alt, {
                [lang]: this.form.title[lang]
            });
        },
        toggle(object, collection, newValue) {
            if (object[collection].find(x => x.id === newValue.id)) {
                object[collection] = object[collection].filter(x => x.id !== newValue.id);
            }
            else {
                object[collection].push(newValue);
            }
        }
    },
    watch: {

    },
    computed: {

    },
    mounted() {
        this.$on('input', () => {
            if (this.$refs.activityLog) {
                this.$refs.activityLog.load();
            }
        });
    },
};
</script>


// WEBPACK FOOTER //
// resources/js/forms/pages/Page.vue